// ============================================================
// The legend's key: what is actually ON this map
// ============================================================

/** One material's row in the key, from the first solid that wears it. */
function materialRow(solid) {
  return {
    key: solid.label,
    name: solid.label,
    colour: solid.colour,
    transparency: solid.transparency ?? (solid.opaque ? 0 : 2),
    permeability: solid.permeability ?? 0,
    hardness: Math.max(1, Math.round(solid.cover?.ap ?? 0)),
  };
}

/**
 * The materials and terrain kinds on the map, for the legend.
 *
 * Not the whole catalogue: a legend that names eight materials when the
 * map has two is a legend nobody reads twice. Materials come from the
 * solids that were meshed, so a material defined and never used does not
 * appear. Hidden solids only for the GM.
 */
export function legendKeyOf(solids, isGm) {
  const shown = solids.filter((solid) => isGm || !solid.hidden);
  const kinds = new Set(shown.filter((solid) => solid.terrain !== 'normal').map((solid) => solid.terrain));
  const byColour = new Map();
  for (const solid of shown) {
    if (solid.label && solid.colour && !byColour.has(solid.label)) byColour.set(solid.label, materialRow(solid));
  }
  return { materials: [...byColour.values()], terrainKinds: [...kinds] };
}
